import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';

import Spacer from '@bequestinc/wui/layout/spacer';
import Typography from '@bequestinc/wui/basics/typography';
import Grid from '@bequestinc/wui/layout/grid';
import Button from '@bequestinc/wui/input/button';

import Page from 'components/Page';
import SettingRow from 'components/SettingRow';
import TableHeader from 'components/TableHeader';
import { useTitle } from 'hooks';
import useCurrentUserQuery from 'hooks/queryHooks/useCurrentUserQuery';
import { startDjangoAdminSession } from 'utils/API';

const useStyles = makeStyles(theme => ({
  root: {
    padding: [[32, 20]],
    [theme.breakpoints.notPhone]: {
      padding: [[32, 60]],
    },
  },
}));

const LoginSettings = ({ showBack }) => {
  const { data: user, isError } = useCurrentUserQuery();
  const classes = useStyles();
  useTitle('Login Settings');

  const goToDjangoAdmin = async () => {
    await startDjangoAdminSession();
    window.location.href = '/admin/';
  };

  return (
    <Page showBack={showBack}>
      <Container maxWidth="md" className={classes.root}>
        <Grid container direction="row" justify="space-between" alignItems="center">
          <div>
            <Typography variant="h3" component="h1">
              Login Settings
            </Typography>
            <Typography variant="body1">Manage your login settings</Typography>
          </div>
          <img width={246} src="/images/file-and-store.png" alt="" />
        </Grid>

        <Spacer v={32} />

        <TableHeader>
          <Typography bold variant="caption">
            LOGIN DETAILS
          </Typography>
        </TableHeader>

        <SettingRow value={user?.email || ''} label="Email" routeTo="/change-email" />
        <SettingRow label="Password" hidden routeTo="/change-password" />
        <Spacer v={24} />
        {isError && (
          <>
            <Typography color="error">
              Couldn't fetch login settings! Please logout and try again.
            </Typography>
            <Spacer v={16} />
          </>
        )}
        {user?.hasDjangoAdminAccess && (
          <>
            <Button
              onClick={goToDjangoAdmin}
              variant="contained"
              color="primary"
              type="submit"
              noMinWidth
              size="large"
            >
              Django Admin
            </Button>
            <Spacer v={16} />
          </>
        )}
      </Container>
    </Page>
  );
};

LoginSettings.propTypes = {
  showBack: PropTypes.bool,
};

LoginSettings.defaultProps = {
  showBack: true,
};

export default observer(LoginSettings);
